import { IEfficiencyTargetsRequest } from '../../interfaces/efficiency-targets.interface'
import { IServiceAdvisorListRequest } from '../../interfaces/service-advisor-list.interface'
import { IServiceAdvisorSummaryRequest } from '../../interfaces/service-advisor-summary.interface'
import { ITechnicianListRequest } from '../../interfaces/technician-list.interface'
import { ITechnicianSummaryRequest } from '../../interfaces/technician-summary.interface'

export class GetLaborSummary {
  static readonly type = '[technician] Get Labor Summary'
  constructor(public payload: ITechnicianSummaryRequest) {}
}

export class GetTechnicianSummary {
  static readonly type = '[technician] Get Technician Summary'
  constructor(public payload: ITechnicianSummaryRequest) {}
}

export class GetTechnicianList {
  static readonly type = '[technician] Get Technician List'
  constructor(public info: ITechnicianListRequest) {}
}

export class GetServiceAdvisorSummary {
  static readonly type = '[technician] Get Service Advisor Summary'
  constructor(public payload: IServiceAdvisorSummaryRequest) {}
}

export class GetServiceAdvisorList {
  static readonly type = '[technician] Get Service Advisor List'
  constructor(public info: IServiceAdvisorListRequest) {}
}

export class AdminGetEfficiencyTargets {
  static readonly type = '[technician] Admin Get Efficiency Targets'
}

export class AdminUpdateEfficiencyTargets {
  static readonly type = '[technician] Admin Update Efficiency Targets'
  constructor(public payload: IEfficiencyTargetsRequest) {}
}
